import { useState } from 'react';
import { useSelector, useDispatch } from "react-redux";
import NotificationsIcon from '@mui/icons-material/Notifications';
import { useTranslation } from 'react-i18next';
import {
    AppBar,
    Badge,
    Box,
    Button,
    Dialog,
    DialogActions,
    DialogContent,
    DialogTitle,
    Divider,
    Icon,
    IconButton,
    Menu,
    MenuItem,
    Paper,
    Switch,
    Toolbar,
    Tooltip,
    Typography
} from '@mui/material';
import ClearAllRoundedIcon from '@mui/icons-material/ClearAllRounded'
import ClearIcon from '@mui/icons-material/Clear'
import UIButton from 'component/ui/form/UIButton';
import { clearNotificationById, clearNotificationsList } from 'redux/features/popoverSlice';
import { epochConverter } from 'config/helpers/date_helper';

const NotificationsBell = () => {
    const notificationsList = useSelector(state => state?.popover?.notificationsList);
    const theme = useSelector(state => state?.currentUser?.theme);

    // State to manage menu anchor and open status
    const [open, setOpen] = useState(false);

    // Function to handle clicking the notification bell
    const handleClick = (event) => {
        setOpen(true)
    };

    // Function to handle closing the menu
    const handleClose = () => {
        setOpen(false)
    };

    return (
        <div className='pe-3' style={{ marginLeft: 'auto' }}> {/* Align to right */}
            <IconButton
                onClick={handleClick} // Attach the click handler
                color="inherit"
            >
                <Badge badgeContent={notificationsList?.length} color="secondary">
                    <NotificationsIcon style={{ color: theme === 'light' ? '#3d2470' : 'inherit' }} />
                </Badge>
            </IconButton>
            {/* Menu component */}
            {/* <Menu
          id="notification-menu"
          anchorEl={anchorEl}
          keepMounted
          open={open}
          onClose={handleClose}
        >
          {notificationsList?.length > 0 ? (
            notificationsList.map((notification, index) => (
              <MenuItem key={index} onClick={handleClose}>
                {JSON.stringify(notification)}
              </MenuItem>
            ))
          ) : (
            <MenuItem onClick={handleClose}>No notifications right now</MenuItem>
          )}
        </Menu> */}
            <NotificationModal open={open} onClose={handleClose} />
        </div>
    );
};

export default NotificationsBell


const NotificationModal = ({ open, onClose }) => {
    const theme = useSelector(state => state?.currentUser?.theme)
    const notificationMessage = useSelector(state => state?.popover?.notificationsList)
    const reduxDispatch = useDispatch()

    const { i18n } = useTranslation()
    const message = i18n.t('notifications.MESSAGE')
    const handleClearAllNotifications = () => {
        reduxDispatch(clearNotificationsList())
    }
    const handleDeleteNotification = (data) => {
        reduxDispatch(clearNotificationById(data));
    };
    

    return (
        <Dialog open={open} onClose={onClose}>
            <Box
                sx={{
                    position: 'fixed',
                    top: '64px',
                    right: '2rem',
                }}
            >
                <Paper
                    sx={{
                        width: '300px',
                        MinHeight: '200px',
                        boxShadow: theme === 'dark' ? '0px 1px 5px 7px rgba(0,0,0,0.2) !important' : '0px 0px 20px 5px rgb(0 0 0 / 26%) !important'
                    }}
                >
                    <Box
                        sx={{
                            display: 'flex',
                            justifyContent: 'space-between',
                            alignItems: 'center',
                        }}
                    >
                        <DialogTitle sx={{ paddingLeft: '14px' }}>
                            {i18n.t('notifications.NOTIFICATION')}
                        </DialogTitle>
                        <Tooltip
                            enterTouchDelay={0}
                            disableInteractive
                            placement="left"
                            title={i18n.t('common.CLEAR_ALL')}
                        >
                            <IconButton
                                sx={{
                                    height: '50px',
                                    width: '50px',
                                    borderRadius: '50%',
                                    marginRight: '10px',
                                }}
                                onClick={handleClearAllNotifications}
                            >
                                <ClearAllRoundedIcon />
                            </IconButton>
                        </Tooltip>
                    </Box>
                    <Box
                        sx={{
                            maxHeight: '40vh',
                            overflowY:
                                notificationMessage &&
                                    notificationMessage.length > 0
                                    ? 'scroll'
                                    : 'hidden',
                            overflowX: 'visible',
                        }}
                    >
                        {notificationMessage?.length ? (
                            notificationMessage?.map(notification => {
                                return (
                                    <>
                                        <Box
                                            sx={{
                                                display: 'flex',
                                                justifyContent: 'space-between',
                                                alignItems: 'center',
                                                padding: '2px 10px',
                                                margin: '4px',
                                                background:
                                                    !notification?.isRead
                                                        ? theme == 'light'
                                                            ? '#dfe9f5'
                                                            : theme ==
                                                            'dark' &&
                                                            '#5c5d5e'
                                                        : 'inherit',
                                                borderRadius: '5px',
                                            }}
                                        >
                                            <Typography
                                                fontSize={14}
                                            >
                                                {notification?.notification_heading}
                                                <Typography
                                                    fontSize={10}
                                                >
                                                    <i>
                                                        {epochConverter(
                                                            // Date.now returns milliseconds... Need to convert it to seconds
                                                            parseInt(notification?.notification_time/1000)
                                                        )}
                                                    </i>
                                                </Typography>
                                            </Typography>
                                            <IconButton
                                                onClick={(event) =>
                                                    handleDeleteNotification(notification?.notification_id)
                                                }
                                            >
                                                <ClearIcon />
                                            </IconButton>
                                        </Box>
                                        <Divider variant="middle" />
                                    </>
                                )
                            })
                        ) : (
                            <DialogContent>
                                {i18n.t(
                                    'notifications.NO_NOTIFICATIONS_RIGHT_NOW'
                                )}
                            </DialogContent>
                        )}
                    </Box>
                    <DialogActions >
                        <UIButton callback={onClose} text={i18n.t('notifications.CLOSE')} />
                    </DialogActions>
                </Paper>
            </Box>
        </Dialog>
    )
}